import styled from "styled-components";

export const FaqsWrapper = styled.section`
  .item-wrapper {
    padding-right: 15px;
  }
  .item-container {
    background: var(--white);
    padding: 0;
    margin: 8px 0;
    border: none;
    cursor: pointer;
    box-shadow: 0px 0px 20px 0px rgba(25, 194, 143, 0.3);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(25, 194, 143, 0.3);
    -moz-box-shadow: 0px 0px 20px 0px rgba(25, 194, 143, 0.3);
  }
  .item-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    .item-box-heading {
      color: var(--darkColor);
      font-size: 16px;
      font-family: var(--lightMedium);
    }
    .item-box-text {
      color: var(--text);
      font-size: 16px;
      font-family: var(--book);
      margin: 0;
      padding: 0 20px 20px 20px;
    }
    & > svg {
      [stroke] {
        stroke: var(--darkColor);
      }
      [fill] {
        fill: var(--darkColor);
      }
      width: 16px;
      height: 16px;
    }
  }

  .more-btn{
    cursor: pointer;
  }

  .active-item-box {
    background: var(--white);
    .item-box-heading {
      /* padding-bottom: 10px; */
    }
    .item-box-text {
      color: var(--text);
      font-size: 16px;
      font-family: var(--book);
      margin: 0;
      padding: 0 20px 20px 20px;
    }
    & .border-bottom-line {
      border-bottom: 1px solid #149f72;
    }
    & > .item-box {
      color: var(--white);
      position: relative;
    }
  }
  @media (max-width: 991px) {
    padding-top: 10px;
  }
`;
